// Centralized brand constants. Used in listing copy, the App Bridge title,
// the support page, and other merchant-visible surfaces.

export const BRAND = {
  // Hardcoded, NOT env-read. BRAND is imported by BOTH the SSR and the browser bundles; a
  // `process.env.*` read here resolves on the server but is undefined in the browser, so any
  // env-derived value rendered into a page differs between SSR and client hydration and triggers
  // React hydration mismatches (#418/#423) on every page that shows it — and React then recovers
  // using the (wrong) client value. Keep these literal so SSR === client.
  name: "EasyNutriFact",
  handle: "easynutrifact",
  tagline: "FDA-style Nutrition Facts labels generated and saved on your Shopify store.",
  // Monitored support inbox shown on the legal/support pages + the App Store listing.
  supportEmail: "info+support@legitimateapps.com",
  primaryColor: "#1f4cff",
  secondaryColor: "#16a34a",
} as const;

// The canonical public origin — the only host that may appear in a sitemap <loc>, a
// robots Sitemap: directive, a canonical link, or llms.txt. Hardcoded for the same
// SSR/client-parity reason as BRAND above.
//
// This is the live registered domain. Keeping the host here prevents canonical URLs
// from drifting across routes. Quote Desk's version of that scatter is documented in
// quote-desk/test/marketing-canonical-host.test.ts.
export const SITE_ORIGIN = "https://factsmaker.com";

// Search-result title for the public homepage. Keep this distinct from the
// longer product tagline: combining the app name and tagline produces titles
// that search engines truncate.
export const PAGE_TITLE = "EasyNutriFact — FDA-Style Labels for Shopify";

// One local social card shared by every public route. Because the absolute URL
// derives from SITE_ORIGIN, the future domain cutover remains a one-line edit.
export const SOCIAL_IMAGE = {
  url: `${SITE_ORIGIN}/easynutrifact-og.png`,
  width: "1200",
  height: "630",
  alt: "EasyNutriFact showing an FDA-style Nutrition Facts panel for Shopify",
} as const;
